var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "metadata"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _c('section', {
    staticClass: "stats"
  }, [_c('article', [_c('div', {
    staticClass: "stat"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Subnets "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of subnets on Avalanche"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalSubnets.toLocaleString()) + " ")])])]), _c('article', [_c('div', {
    staticClass: "stat"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Blockchains "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of blockchains on Avalanche"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalBlockchains.toLocaleString()) + " ")])])]), _c('article', [_c('div', {
    staticClass: "stat"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Validators "), _c('TooltipMeta', {
    attrs: {
      "content": "Total number of nodes validating transactions on Avalanche"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalValidators.toLocaleString()) + " ")])])]), _c('article', [_c('div', {
    staticClass: "stat"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v(" Total Stake Amount "), _c('TooltipMeta', {
    attrs: {
      "content": "Total value of AVAX locked to secure Avalanche"
    }
  })], 1), _c('p', {
    staticClass: "meta_val"
  }, [_vm._v(" " + _vm._s(_vm.totalStake.toLocaleString()) + " "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("AVAX")])])])])])])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("Subnets")])]);
}]

export { render, staticRenderFns }